import React from 'react';
import { theme } from '../../config/theme';

const Badge = ({ 
  children, 
  variant = 'default',
  size = 'md',
  className = '' 
}) => {
  const variants = {
    default: {
      backgroundColor: theme.colors.gray[100],
      color: theme.colors.gray[700],
    },
    primary: {
      backgroundColor: theme.colors.primary.light,
      color: theme.colors.primary.dark,
    },
    success: {
      backgroundColor: `${theme.colors.success}20`,
      color: theme.colors.success,
    },
    error: {
      backgroundColor: `${theme.colors.error}20`,
      color: theme.colors.error,
    },
    warning: {
      backgroundColor: `${theme.colors.warning}20`,
      color: theme.colors.warning,
    },
    info: {
      backgroundColor: `${theme.colors.info}20`,
      color: theme.colors.info,
    },
  };

  const sizes = {
    sm: {
      padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
      fontSize: theme.typography.fontSize.xs,
    },
    md: {
      padding: `${theme.spacing.xs} ${theme.spacing.md}`,
      fontSize: theme.typography.fontSize.sm,
    },
    lg: {
      padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
      fontSize: theme.typography.fontSize.base,
    },
  };

  const badgeStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: theme.borderRadius.full,
    fontWeight: theme.typography.fontWeight.medium,
    ...variants[variant],
    ...sizes[size],
  };

  return (
    <span className={className} style={badgeStyles}>
      {children}
    </span>
  );
};

export default Badge;